/**
 * @param {number} number
 */

export function formatNumberWithThousandSeparator(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}
